// @section 1 useIsMobile — viewport fork for the My Day surface (F8).
// The same My Day data renders two different layouts: the desktop two-pane
// (ranked list + calendar) and the mobile single-column. This hook is the
// switch. matchMedia so it reacts to rotate/resize without a reload.

import { useEffect, useState } from 'react';

// @block 1.1 True on phone-width viewports (< breakpoint). Default 768px = the
// Tailwind md breakpoint, so tablets and up keep the desktop two-pane.
export function useIsMobile(breakpointPx = 768): boolean {
  const query = `(max-width: ${breakpointPx - 1}px)`;
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);
  return isMobile;
}
